import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useGetProfileQuery } from 'store/slices/profile-api';
import DisableTwoFactor from './disable/DisableTwoFactor';
import EnableTwoFactor from './enable/EnableTwoFactor';

export const Route = createFileRoute('/_authenticated/settings/two-factor')({
  component: TwoFactor,
});

function TwoFactor() {
  const { data: userProfileResponse } = useGetProfileQuery();
  const [state] = useState(userProfileResponse?.twoFactorStatus?.activated);

  if (state) return <DisableTwoFactor />;

  return <EnableTwoFactor />;
}
